import { buildUrl } from "../../../ReusableFunctions/reusableFunctions";
import { SERVER_URLS } from "../../../appConstants";
import { getToken } from "../../authentication";

// export const getNearbyDspLocations = async ({cropName,fieldLat,fieldLng,fieldArea}) => {
//     try {
//             const token = getToken();
//             const url = buildUrl(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/customerSuccessEngineer/leadOrders`, {
//                  crop_name: cropName ||  '',
//             field_lat: fieldLat  || '',
//             field_lng: fieldLng  ||  '',
//             field_area: fieldArea ||  ""
//             });
//             const response = await fetch(url,
//                 {
//                     method: "GET",
//                     headers: {
//                         Authorization: `Bearer ${token} `,
//                     },
//                 }
//             );


// export const getNearbyDspLocations = async ({cropName,fieldLat,fieldLng,fieldArea}) => {
//     try {
//             const token = getToken();
//             const url = buildUrl(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/customerSuccessEngineer/leadOrders`, {
//                  crop_name: cropName ||  '',
//             field_lat: fieldLat  || '',
//             field_lng: fieldLng  ||  '',
//             field_area: fieldArea ||  ""
//             });
//             const response = await fetch(url,
//                 {
//                     method: "GET",
//                     headers: {
//                         Authorization: `Bearer ${token} `,
//                     },
//                 }
//             );
    
//             const res = await response.json();
//             if (!response.ok) {
//                 throw (res.message || "Something went wrong while getting nearby dsp locations");
//             }
//             return res.nearByLocations || [];
//     } catch (err) {
//         throw (err)
//     }
// }


export const createLeadOrder = async (request) => {
    try {
            const token = getToken();
            const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/customerSuccessEngineer/leadOrders`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token} `,
                        
                    },
                    body: JSON.stringify({ request })
                }
            );
    
            const res = await response.json();
            if (!response.ok) {
                throw (res.message || "Something went wrong while getting coupons");
            }
            return res?.parameters;
    } catch (err) {
        throw (err)
    }
}

export const getAllCrops = async () => {
    try{
        const token = getToken();
        const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/customerSuccessEngineer/leadOrders`,
            {
                method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token} `,
                        
                    }, 
            }
        )

        const res = response.json();
        if (!response.ok) {
            throw(res.message || "Something went wrong while getting crops list");
        }
        return res?.crops

    } catch(err) {
     throw (err)
    }
}
